import type { CSSProperties } from 'react';

import { Importe } from './Importe';
import { color } from './tokens';

type ImporteMovimientoProps = {
  /** Céntimos enteros. */
  valor: number;
  style?: CSSProperties;
  'data-testid'?: string;
};

/**
 * Importe de una fila de movimiento (H61), igual en Gastos, movimientos de
 * una cuenta y Revisar: «+» y verde en los ingresos, gris el cero y los
 * gastos con «-» en el color del texto (no en rojo: gastar es lo normal).
 */
export function ImporteMovimiento({
  valor,
  style,
  'data-testid': testId,
}: ImporteMovimientoProps) {
  return (
    <Importe
      valor={valor}
      conSigno
      data-testid={testId}
      style={{
        fontSize: 14,
        fontWeight: 800,
        color: valor > 0 ? color.ok : valor === 0 ? color.fg3 : color.fg,
        ...style,
      }}
    />
  );
}
